import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";

const Footer = () => (
  <StaticQuery
    query={graphql`
      query {
        wordpressSiteMetadata {
          name
        }
        footerMenu: wordpressWpApiMenusMenusItems(slug: { eq: "footer" }) {
          name
          items {
            title
            url
          }
        }
        socialMenu: wordpressWpApiMenusMenusItems(slug: { eq: "social" }) {
          name
          items {
            title
            url
          }
        }
      }
    `}
    render={data => {
      const menu = data.footerMenu;
      const siteTitle = data.wordpressSiteMetadata.name;
      menu.items.map(item => {
        let parts = item.url.split("/");
        parts = parts.slice(3);
        item.slug = parts.join("/");
        return item.slug;
      });
      return (
        <footer className="footer">
          <div className="container">
            <div className="columns is-multiline">
              <div className="column is-8">
                <ul>
                  {menu.items.map(item => (
                    <li key={item.title}>
                      <Link to={`/${item.slug}`}>{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="column is-4">
                <ul>
                  {data.socialMenu.items.map(item => (
                    <li key={item.title}>
                      <a href={item.url}>{item.title}</a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="column is-12 has-text-centered">
                <p>
                  © {new Date().getFullYear()} <Link to="/">{siteTitle}</Link>.
                  All rights reserved.
                </p>
                <small>
                  Website by{" "}
                  <a
                    href="https://www.iamtimsmith.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tim Smith
                  </a>
                </small>
              </div>
            </div>
          </div>
        </footer>
      );
    }}
  />
);

export default Footer;
